import React, { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { changeIntervalOption } from "../../../actions/enrollmentActions";
import { Select } from "cxa-components";
import { formatMoney } from "./EnrollmentDataUtil";

const IntervalOptions = ({ plan, benefitId, disabled = false, intl }) => {
  const dispatch = useDispatch();
  if (!Array.isArray(plan.intervalOptions) || plan.intervalOptions.length <= 0) {
    return "";
  }
  const onIntervalOptionChange = e => {
    e.preventDefault();
    dispatch(changeIntervalOption(plan, benefitId, e.target.value));
  };

  const selectedOption = plan.intervalOptions.find(x => x.isSelected);

  return (
    <div className="product-plan__options">
      <strong>
        {intl.formatMessage({ id: plan.descriptionLine2, defaultMessage: plan.descriptionLine2 })}
      </strong>
      <Select
        value={(selectedOption && selectedOption.interval) || plan.intervalOptions[0].interval}
        onChange={onIntervalOptionChange}
        disabled={disabled}
      >
        {plan.intervalOptions.map(option => {
          return (
            <option
              key={option.name}
              className="benefit-plan__dependant-selection"
              value={option.interval}
              // disabled={!isSelected}
            >
              {formatMoney(option.planValue && option.planValue.numericValue)}
            </option>
          );
        })}
      </Select>
    </div>
  );
};
IntervalOptions.propTypes = {
  benefitId: PropTypes.string.isRequired,
  plan: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  intl: PropTypes.func,
};
export default IntervalOptions;



// WEBPACK FOOTER //
// ./components/employee/shop/PlanIntervalOptionsPP.js